import {
	comMapping
} from '../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},{
				prop: "bbzt",
				label: '报表状态',
				type: "select",
				selectval: [{
							label: "审核中",
							value: "2",
						},
						{
							label: "审核成功",
							value: "3",
						},
						{
							label: "审核失败",
							value: "4",
						},
						{
							label: "申报中",
							value: "5",
						},
						{
							label: "申报成功",
							value: "6",
						},
						{
							label: "申报失败",
							value: "7",
						},{
							label: "缴款成功",
							value: "9"
						},
						{
							label: "缴款失败",
							value: "10"
						},{
							label: "缴款中",
							value: "10"
						},]
			},
			{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "shuiBid",
				label: '申报种类',
				type: "select",
				selectval: comMapping.$declareTypeMapping,
			},
			{
				prop: "sbqqList",
				label: '税款所属期间',
				type: "date"
			},
			{
				prop: "ybtse",
				label: '应补（退）税额（附加税额）',
				type: "inputplus"
			},
			{
				prop: "fqsjList",
				label: '发起时间',
				type: "date"
			},
			{
				prop: "fqr",
				label: '发起人',
				type: "input",
			},
			{
				prop: "dqclr",
				label: '当前处理人',
				type: "input",
			},
			
		],
		searchdata: {
			nsrmc: "",
			companyCode: "",
			shuiBid: "",
			fqr: '',
			dqclr: '',
			bbzt: "",
			sbqqList: [],
			fqsjList: [],
			ybtse: []

		},
		headseeData:[
			{
				title: "类型",
				prop: "type",
				custom:true
			},
			{
				title: "名称",
				prop: "name",
			},
			{
				title: "描述",
				prop: "description",
				width:"200"
			},
			{
				title: "操作",
				prop: "cz",
				custom:true,
				width:"120"
			},
		],
		paginationfile:{
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey:0
		},
		headData: [{
				title: "序号",
				prop: "num",
				width: "80",
				issort: true,
			},
			{
				title: "纳税人名称",
				prop: "nsrmc",
				width: 110,
				
				custom:true,
				issort: true
			},
			{
				title: "公司代码",
				prop: "companyCode",
				custom:true,
				width: "100",
				issort: true
			},
			{
				title: "税款所属期",
				prop: "shuikssqTime",
				custom:true,
				width: "110",
				issort: true
			},
			{
				title: "申报种类",
				prop: "shenbzl",
				width: 100,
				issort: true,
				custom: true
			},
			{
				title: "应补（退）税额（附加税额）",
				prop: "yingbts",
				width: "130",
				AmountFormat: true,
				issort: true,
				custom: true
			},
			{
				title: "发起时间",
				prop: "startTime",
				width: 80,
				custom: true
			},
			{
				title: "发起人",
				prop: "startName",
				custom: true,
				width: "80",
			},
			{
				title: "当前处理人",
				prop: "dangqclr",
				width: 100,
				custom: true,
				
			},
			{
				title: "报表状态",
				prop: "reportStatus",
				width: "120",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				custom: true,
				fixed: "right"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		zhongdianxxfeny: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formlist: [{
			prop: "type",
			label: "类型",
			type: "select",
			width:"220px",
			selectval:[
				{
					label:"报表 ",
					value:"1"
				},
				{
					label:"完税凭证",
					value:"2"
				},
				{
					label:"涉税资料",
					value:"3"
				}
			]
		
		},{
			prop: "name",
			label: "名称",
			type: "input",
			width:"220px"
		
		},{
			prop: "description",
			label: "描述",
			type: "textarea",
			width:"380px"
		
		}], 
		headDatash: [{
				title: "项目",
				custom:true,
				prop: "xiangmName",
				width: 160,
			},
			{
				title: "税局数据",
				prop: "shuijValue",
				width: 160,
				AmountFormat:true,
				custom:true,
			},
			{
				title: "调整（数据治理）",
				prop: "caiwValue",
				width: 160,
				AmountFormat:true,
				custom:true,
			},
			{
				title: "申报数据",
				custom:true,
				prop: "cellValue",
				width: 160,
				AmountFormat:true,
			},
			{
				title: "调整说明",
				prop: "adjustDesc",
				width: 160,
				AmountFormat:true,
				custom:true,
			},
			{
				title: "对比结果",
				prop: "result",
				width: "80",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "150",
				custom: true
			},
		],
		headDataxzyw: [{
				title: "选择",
				prop: "xz",
				width: "100",
				custom: true
			},
			{
				title: "业务科目代码",
				prop: "yewkmCode",
				width: 100,
			},
			{
				title: "业务科目名称",
				prop: "yewkmName",
				width: 160,
				align: "left"
			},
			{
				title: "说明",
				prop: "description",
				width: 160,
				align: "left"
			},
		],
		baobiesjfenye: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationywkm: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatabb: [{
				title: "选择",
				prop: "xz",
				width: "80",
				custom: true
			},
			{
				title: "格子代码",
				prop: "cellCode",
				width: 100,
			},
			{
				title: "格子名称",
				prop: "cellName",
				width: 160,
				align: "left"
			},
		]
	}
	return obj
}
